/* eslint-disable */
const routeContact = [
    {
        path: '/contact',
        name: 'Contact',
        component: () => import('../pages/contact/Contact.vue'),
        meta: {
            layout: 'BlankLayout',
        },
    }
]
  
export default routeContact;